export const REPLAY_ENABLED_GUIDE_NAMES = ['aria-modal', 'keyboard', 'forms'];
